import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSearch = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	"data-name": "Layer 1",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 25 25",
	...props,
	children: [/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: "\n      .search-cls-2 {\n        fill: currentColor\n      }\n    " }) }), /* @__PURE__ */ _jsx("path", {
		id: "Path_18",
		"data-name": "Path 18",
		className: "search-cls-2",
		d: "M17.272,15.427A8.125,8.125,0,1,0,10.68,18.8h0a8.128,8.128,0,0,0,4.749-1.539l5.179,5.179,1.837-1.837Zm-6.589.775a5.528,5.528,0,1,1,3.908-1.62,5.528,5.528,0,0,1-3.908,1.62Z"
	})]
});
export default SvgSearch;
